// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { List, Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetCountries (params?: {}): Promise<List>;
    publicGetCurrencies (params?: {}): Promise<List>;
    publicGetDataCurrencyTicker (params?: {}): Promise<Dict>;
    publicGetDataCurrencyTrades (params?: {}): Promise<List>;
    publicGetDataCurrencyDepth (params?: {}): Promise<Dict>;
    publicGetBitcoinChartsIdTrades (params?: {}): Promise<List>;
    publicGetBitcoinChartsIdDepth (params?: {}): Promise<Dict>;
    privateGetUser (params?: {}): Promise<Dict>;
    privateGetUserAddresses (params?: {}): Promise<List>;
    privateGetUserAddressesAddress (params?: {}): Promise<Dict>;
    privateGetUserOrders (params?: {}): Promise<List>;
    privateGetUserOrdersUuid (params?: {}): Promise<Dict>;
    privateGetUserPriceAlerts (params?: {}): Promise<List>;
    privateGetMerchantGetPaymentUuid (params?: {}): Promise<Dict>;
    privatePostUserAddresses (params?: {}): Promise<Dict>;
    privatePostUserOrders (params?: {}): Promise<Dict>;
    privatePostUserWithdrawals (params?: {}): Promise<Dict>;
    privatePostUserEmailTransfers (params?: {}): Promise<Dict>;
    privatePostUserPaymentRequests (params?: {}): Promise<List>;
    privatePostUserPriceAlerts (params?: {}): Promise<Dict>;
    privatePostMerchantCreatePayment (params?: {}): Promise<Dict>;
    privateDeleteUserOrdersUuid (params?: {}): Promise<Dict>;
    privateDeleteUserOrdersUuidCancel (params?: {}): Promise<Dict>;
    privateDeleteUserPriceAlertsId (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
